<template>
	<div class="consulta-dej">
		<v-container  
				class="overflow-y-auto"
		>
            <v-layout row>
				<v-flex md9 xs12 class="pt-5 pa-4">
                    <v-row>
                        <v-col cols="12" md="12" class="mt-10 pt-5">
                            <h2 class="text-center">Consulta de Depósitos Judiciales de alimentos</h2>
                        </v-col>
                        <v-col cols="12" md="4" xs="12" offset-md="4">
                            <v-card class="pa-5">
                                <v-card-text>
                                    <v-form @submit.prevent="handleSubmit" ref="form" v-model="valid" lazy-validation>
                                        <v-row>
                                            <h4 class="text-center mb-5">Bienvenido, ingrese la información solicitada para verificar</h4>
                                            <v-col cols="12" md="12" class="mb-0 py-0">
                                                <v-text-field
                                                    v-model="form.dni"
                                                    label="DNI"
                                                    outlined dense
                                                    prepend-icon="mdi-card-account-details"
                                                    ref="dni"
                                                    :rules="[rules.required, rules.dni, rules.entero]"
                                                    :minlength=8    
                                                    :maxlength=8
                                                    
                                                />        
                                            </v-col>
                                            <v-col cols="12" md="12" class="mx-0 py-0">
                                                <v-text-field
                                                    v-model="form.ap_paterno"
                                                    label="Apellido Paterno"
                                                    outlined dense
                                                    prepend-icon="mdi-alphabetical"
                                                    :rules="[rules.required]"
                                                />   
                                            </v-col>
                                            <v-col cols="12" md="12" class="mx-0 py-0">
                                                <v-text-field
                                                    v-model="form.digito"
                                                    label="Dígito de verificación"
                                                    outlined dense
                                                    prepend-icon="mdi-numeric"
                                                    :rules="[rules.entero, rules.required]"
                                                    :minlength=1    
                                                    :maxlength=1
                                                />   
                                            </v-col>
                                            <v-col cols="12" md="12" class="mx-0 py-0">
                                                <v-menu
                                                    v-model="datetime"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field
                                                            v-model="form.f_nacimiento"
                                                            label="Fecha de Inicio"
                                                            prepend-icon="mdi-calendar"
                                                            v-on="on"
                                                            hint="DD/MM/YYYY"
                                                            persistent-hint
                                                            outlined dense
                                                            @blur="date_inicio = parseDate(form.f_nacimiento)"
                                                            :rules="[rules.required, rules.date]"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker 
                                                        v-model="date_inicio"
                                                        locale="es-419"
                                                        @input="datetime = false"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" md="12" class="ml-10 mx-0 py-0">
                                                <div class="g-recaptcha" :data-sitekey="recaptchaSiteKey"></div>
                                            </v-col>

                                            <v-col cols="12" md="12" class="mt-2 pt-0">
                                                <v-btn block color="red darken-4" dark type="submit">
                                                    <v-icon>mdi-magnify</v-icon>
                                                    Consultar
                                                </v-btn>
                                            </v-col>    
                                        </v-row>
                                    </v-form>
                                </v-card-text>  
                            </v-card>
                        </v-col>
                    </v-row>
                </v-flex>

                <v-flex md3 xs12>
					<Servicios />
				</v-flex>

            </v-layout>
                
        </v-container>

        <v-dialog
            v-model="d_response"
            max-width="600"
            transition="dialog-bottom-transition"
            persistent
        >
            <v-card>
                <v-card-title class="text-h5">
                    Depósito Electrónico Judicial
                </v-card-title>
                <v-card-text>
                    <v-row class="pt-5" justify="center">
                        <v-col cols="12" md="12">
                            <div class="text-center">
                                <v-avatar
                                    class="ma-3"
                                    :size="(response)?85:125"
                                    tile
                                >
                                    <v-icon size="85" v-if="response" color="success">mdi-check</v-icon>
                                    <v-icon size="125" v-else color="error">mdi-alert</v-icon>
                                </v-avatar>
                                <template v-if="response">
                                    <h2 >
                                        Ud. SI tiene DEPOSITO(s) por cobrar
                                    </h2>
                                    <v-simple-table>
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                Nro. de Depósito
                                            </th>
                                            <th class="text-left">
                                                Depósito
                                            </th>
                                            <th class="text-left">
                                                Resolución
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                        v-for="item in depositos"
                                        :key="item.name"
                                        >
                                        <td>{{ item.NUM_DEP_JUDICIAL }}</td>
                                        <td><v-icon>mdi-file-pdf</v-icon></td>
                                        <td><v-icon>mdi-file-pdf</v-icon></td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>
                                </template>
                                <h2 v-else>
                                    Ud. NO tiene DEPOSITO(s) por cobrar
                                </h2>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="d_response = false"
                    >
                        Cerrar
                    </v-btn>
                    </v-card-actions>
            </v-card>

        </v-dialog>
        <v-snackbar v-model="snack.snackShow" top center :timeout="6000"  :color="snack.snackColor" absolute style="z-index: 999999 !important;">
            {{ snack.snackText }}
            <template v-slot:action="{ attrs }">
            <v-btn text @click="snack.snackShow = false" v-bind="attrs"><v-icon>mdi-close</v-icon></v-btn>
            </template>
        </v-snackbar>
        <v-dialog v-model="dialogLoad.show" persistent :width="290" transition="dialog-transition">
        <v-card dark :color="dialogLoad.color">
            <v-card-text>
                {{dialogLoad.text}}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios';

    const Servicios = () => import('@/components/Servicios.vue')
	export default {
		components: {
			Servicios
		},
        data() {
            return {
                form: {
                    dni: '',
                    digito: '',
                    ap_paterno: '',
                    f_nacimiento: '',
                    f_nacimientop: '',
                    recaptcha: ''
                },
                valid: true,
                snack: {snackShow:false, snackText: '', snackColor: '',},  
                dialogLoad: {show:false, text: '', color: '',},
                recaptchaSiteKey: '6LcqZJ0eAAAAANq_wpSOFEMMyVs9pVdFpzK6VGcq',
                datetime: false,
                date_inicio: this.parseDate(new Date().toLocaleDateString()),
                d_response:true,
                response:true,
                depositos:[],
                rules: {
                    entero: v => v >= 0 || 'El campo solo admite números',
                    required: v => !!v || 'Descripcion Requerido',
                    dni: v=> v != undefined && v.length == 8 || 'Longitud incorrecta',
                    date: value => {
                        const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
                        return pattern.test(value) || 'Fecha no valida'
                    }
                },
            }
        },
        watch:{
            date_inicio (val) {
                this.form.f_nacimiento = this.formatDate(this.date_inicio)
            },
        },
        mounted() {
        if (!window.grecaptcha) {
            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js';
            script.async = true;
            script.defer = true;
            script.onload = () => {
                this.scriptLoaded = true;
                //console.log('reCAPTCHA cargado');
            };
            document.head.appendChild(script);
            } else {
            this.scriptLoaded = true;
            }
        },
        methods: {
            async handleSubmit() {
                const recaptchaResponse = grecaptcha.getResponse();

                if (!recaptchaResponse) {
                    this.showSnack('warning', 'Por favor verifica el captcha')
                    return;
                }

                if (!this.$refs.form.validate() || this.form.dni == null || this.form.dni == '' || this.form.ap_paterno == null || this.form.ap_paterno == '' || this.form.f_nacimiento == null || this.form.f_nacimiento == '' ) {
                    this.showSnack('warning', 'Por favor verifica el captcha')
                    return;
                }

                this.form.recaptcha = recaptchaResponse;
                this.form.f_nacimientop = this.parseDate(this.form.f_nacimiento);
                if(this.$refs.form.validate()){
                    this.showLoad(true, 'red darken-2', 'Consultando')
                    try {
                        const response = await axios.post('https://alimentos.csjpuno.pe/api/consultarDJE', this.form)
                                                .then(response => {
                                                    if(response.data['data']['dje']){
                                                        this.response = true;
                                                        this.d_response = true;
                                                        this.depositos = response.data['data']['depositos'];
                                                        console.log("mostrar dialogo1")
                                                    } else{
                                                        console.log("mostrar dialogo2")
                                                    }
                                                    this.showSnack('success', response.data.message)
                                                    this.showLoad(false)
                                                })
                                                .catch(errors =>{
                                                    this.showLoad(false)
                                                    this.showSnack('warning', 'Ocurrió un error en la consulta')
                                                });
                        
                    } catch (error) {
                        this.showLoad(false)
                        this.showSnack('warning', 'Ocurrió un error en la consulta')
                    }
                }
                
            },
            parseDate (date) {
                if (!date) return null
                    const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            showSnack(color, text, show = true){
                this.snack.snackColor = color
                this.snack.snackText = text
                this.snack.snackShow = show
            },
            showLoad(show = true, color, text){
                this.dialogLoad.color = color
                this.dialogLoad.text = text
                this.dialogLoad.show = show
            },
        },
	}

</script>
